export default {
  'component.globalHeader.search': '站内搜索',
  'component.globalHeader.search.example1': '搜索提示一',
  'component.globalHeader.search.example2': '搜索提示二',
  'component.globalHeader.search.example3': '搜索提示三',
  'component.globalHeader.help': '使用文档',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': '你已查看所有通知',
  'component.globalHeader.message': '消息',
  'component.globalHeader.message.empty': '您已读完所有消息',
  'component.globalHeader.event': '待办',
  'component.globalHeader.event.empty': '你已完成所有待办',
  'component.noticeIcon.clear': '清空',
  'component.noticeIcon.cleared': '清空了',
  'component.noticeIcon.empty': '暂无数据',
  'component.noticeIcon.view-more': '查看更多',
  'component.avatarDropdown.user': '用户',
  'component.avatarDropdown.changePassword': '修改密码',
  'component.avatarDropdown.logout': '退出登录',
  'component.avatarDropdown.changePassword.title': '修改密码',
  'component.avatarDropdown.changePassword.ok': '确定',
  'component.avatarDropdown.changePassword.cancel': '取消',
  'component.avatarDropdown.changePassword.oldPassword.label': '旧密码',
  'component.avatarDropdown.changePassword.oldPassword.required': '请输入旧密码',
  'component.avatarDropdown.changePassword.oldPassword.min': '密码长度不能少于6个字符',
  'component.avatarDropdown.changePassword.oldPassword.placeholder': '请输入旧密码',
  'component.avatarDropdown.changePassword.newPassword.label': '新密码',
  'component.avatarDropdown.changePassword.newPassword.required': '请输入新密码',
  'component.avatarDropdown.changePassword.newPassword.length': '密码长度为6-20个字符',
  'component.avatarDropdown.changePassword.newPassword.placeholder': '请输入新密码',
  'component.avatarDropdown.changePassword.confirmPassword.label': '确认密码',
  'component.avatarDropdown.changePassword.confirmPassword.required': '请确认新密码',
  'component.avatarDropdown.changePassword.confirmPassword.mismatch': '两次输入的密码不一致',
  'component.avatarDropdown.changePassword.confirmPassword.placeholder': '请再次输入新密码',
  'component.avatarDropdown.changePassword.success': '密码修改成功，请重新登录',
  'component.avatarDropdown.changePassword.failure': '密码修改失败',
};
